export const initHamburgerMenu = () => {
  const body = document.body;
  const hamburger = document.getElementById('menu');
  const gnav = document.getElementById('gnav');

  if (!hamburger || !gnav) return;

  const closeMenu = () => {
    hamburger.setAttribute('aria-expanded', 'false');
    gnav.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-nav-open');
    gnav.classList.remove('is-open');
  };

  hamburger.addEventListener('click', () => {
    const expanded = hamburger.getAttribute('aria-expanded') === 'true';

    hamburger.setAttribute('aria-expanded', String(!expanded));
    gnav.setAttribute('aria-hidden', String(expanded));

    body.classList.toggle('is-nav-open', !expanded);
    gnav.classList.toggle('is-open', !expanded);
  });

  // 同一ページ内リンク（ページ遷移が発生しない）をクリックした場合もメニューを閉じる
  gnav.querySelectorAll('a[href]').forEach(link => {
    link.addEventListener('click', () => {
      const url = new URL(link.href, window.location.href);
      const isSamePage = url.pathname === window.location.pathname;

      if (isSamePage) {
        closeMenu();
      }
    });
  });
};